import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields } from '@/plugins/ws';

import {RootState} from "@/store";

type MathSettingsMessage = WebSocketMessageWithFields<'indicator-list' | 'indicator-root' | 'indicator-param-list' | 'indicator-out-list' | 'indicator-set-list', {
  math: unknown;
  types: unknown;
}>;

// Объединенный тип для всех сообщений
type MathWebSocketMessage = MathSettingsMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataMath',
},
  __name: 'math',
  setup(__props) {

const store = useStore<RootState>();



// Типы для WebSocket сообщений компонента math
const handleWebSocketMessage = (data: MathWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-list':
    case 'indicator-root':
    case 'indicator-param-list':
    case 'indicator-out-list':
    case 'indicator-set-list':
      store.dispatch('indicators/wsSetMathSettings', {
        math: data.math,
        types: data.types,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})